import { BaseSyntheticEvent, createContext, useContext } from 'react';

export interface AllowListContextProps {
  handleBack: () => void;
  handleSubmit: (value: any, e?: BaseSyntheticEvent) => void;
  actionType?: 'Update' | 'Create';
  onCancel: () => void;
  tagKeyOptions: Record<string, any>[];
  selectedConditions: Record<string, any>[];
  setSelectedConditions(val: Record<string, any>[]);
  updateFormData: (field: string, value: any) => void;
  updateCriteria: (field: string, value: any) => void;
  resetCriteria: (field: string) => void;
  resourceTypeOptions: Record<string, any>[];
  // isDisabledCriteriaNext/setIsDisabledCriteriaNext removed: the Criteria step computes Next-disabled locally.
  hasEC2Criteria: boolean;
  setHasEC2Criteria: (value: boolean) => void;
}

export const AllowListContext = createContext<AllowListContextProps>({
  handleSubmit: (value: any, e?: BaseSyntheticEvent) => {},
  onCancel: () => {},
  handleBack: () => {},
  tagKeyOptions: [],
  actionType: 'Create',
  updateFormData: (field: string, value: any) => {},
  updateCriteria: (field: string, value: any) => {},
  resetCriteria: (field: string) => {},
  resourceTypeOptions: [],
  setHasEC2Criteria: () => {},
  hasEC2Criteria: false,
  selectedConditions: [],
  setSelectedConditions(val: Record<string, any>[]) {},
});

export const AllowListContextProvider = AllowListContext.Provider;

export const useAllowListContext = () => useContext(AllowListContext);
